import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/Layout"
import ReactMarkdown from "react-markdown"
import SEO from "../components/SEO"

const ComponentName = ({ data }) => {
  const { shortDescription:desc, title, description:content } = data.industry;

  return (
    <Layout>
      <SEO title={title} description={desc}/>
      <section className={"blog-template"}>
        <div className="section-center">
          <article className="blog-content">
            <h3>{title}</h3>
            <ReactMarkdown source={content} />
          </article>
          <Link to={"/industries"} className={"btn center-btn"}>
            industry
          </Link>
        </div>
      </section>
    </Layout>
  )
}

export const query = graphql`
  query GetSingleIndustry($slug: String) {
    industry: strapiIndustries(slug: { eq: $slug }) {
      title
      description
    }
  }
`

export default ComponentName
